import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import RestrictTypeService from '../services/RestrictTypeService';
import VisitTypeService from '../services/VisitTypeService';

const initialState = [];
export const getRestrictTypeListV2 = createAsyncThunk('visitType/', async (payload) => {
    const res = await RestrictTypeService.getRestrictTypeList(payload);
    return res.data;
});

export const updateRestrictTypeV2 = createAsyncThunk('visitType/edit', async (payload) => {
    const res = await RestrictTypeService.updateRestrictTypeV2(payload);
    return res.data;
});

export const addRestrictTypeV2 = createAsyncThunk('visitType/add', async (payload) => {
    const res = await RestrictTypeService.addRestrictTypeV2(payload);
    return res.data;
});

export const getRestrictTypeById = createAsyncThunk('visitType/add', async (id) => {
    const res = await RestrictTypeService.getRestrictTypeById(id);
    return res.data;
});

const RestirctTypeSlice = createSlice({
    name: 'restrictType',
    initialState,
    extraReducers: {
        [getRestrictTypeListV2.fulfilled]: (state, action) => {
            if (action.payload.code === '') {
                return action.payload.data;
            } else {
                return [];
            }
        }

    }
})

const { reducer } = RestirctTypeSlice;
export default reducer;